import UI from "@mile-meeting/mile-ui";
const EmptyMinimumAttendeesSettingItem = () => {
  return (
    <>
      <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-alternative)">
        설정된 최소 참석 인원 제한이 없습니다. 항목을 추가해 주세요.
      </UI.Typography>
    </>
  );
};

export default EmptyMinimumAttendeesSettingItem;
